var rangeNotEmpty = range => Boolean(range && (range.min || range.max));
var getWordWithCount = (singular, plural, rangeParam) => {
  var range = rangeParam || {};
  var isSingular = range.min === 1 && range.max === 1;
  var rangeStart = "".concat(range.min === null ? 'up to ' : range.min);
  var joinerSecondPart = range.max === range.min ? '' : ' - ';
  var joiner = "".concat(range.max === null ? '+' : joinerSecondPart);
  var rangeEnd = "".concat(range.max !== null && range.min !== range.max ? range.max : '');
  var rangeWord = "".concat(rangeStart).concat(joiner).concat(rangeEnd);
  return "".concat(rangeWord, " ").concat(isSingular ? singular : plural);
};
var getTitle = filters => {
  var beds = filters.beds;
  var baths = filters.baths;
  var parking = filters.parking;
  if (rangeNotEmpty(beds) || rangeNotEmpty(baths) || rangeNotEmpty(parking)) {
    var titleParts = [];
    if (rangeNotEmpty(beds)) {
      titleParts.push(getWordWithCount('bed', 'beds', beds));
    }
    if (rangeNotEmpty(baths)) {
      titleParts.push(getWordWithCount('bath', 'baths', baths));
    }
    if (rangeNotEmpty(parking)) {
      titleParts.push(getWordWithCount('park', 'parks', parking));
    }
    return titleParts.join(', ').replace(/,\s(?!.*,\s)/, ' & ');
  }
  return 'Bedroom, bathroom & parking';
};
var buildPropertyFeaturesProps = (_ref, onSelectionChange) => {
  var beds = _ref.beds,
    baths = _ref.baths,
    parking = _ref.parking;
  return {
    beds: beds || {},
    baths: baths || {},
    parking: parking || {},
    onSelectionChange
  };
};
export default buildPropertyFeaturesProps;
export { getTitle as getPropertyFeaturesTitle };